import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import Heading from '@zenbusiness/zui/Heading';
import Paper from '@zenbusiness/zui/Paper';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import Account from '#client/components/Account';

export default function Landing() {
  const auth = useAuthentication();

  if (!auth) {
    return (
      <Heading
        color="error"
        size="2xl"
        weight="bold"
      >
        Not Logged In
      </Heading>
    );
  }

  return (
    <Stack sx={{ ml: '8px', mr: '8px' }}>
      <Heading
        color="green"
        size="2xl"
        weight="bold"
      >
        Authenticated
      </Heading>
      {Object.entries(auth.authentication).map(([key, value]) => (
        <Paper key={key}>
          <Text>{String(key)}</Text>
          <Text>{String(value)}</Text>
        </Paper>
      ))}
      <Heading
        color="green"
        size="2xl"
        weight="bold"
      >
        Account Details
      </Heading>
      <Account />
    </Stack>
  );
}
